import {
    EditListPopup,
    PopupComponent,
    PopupElements
} from './edit-list-popup';
import { ActionCreator, AjaxDispatcher } from './ajax-dispatcher';
import { initCompanyAddress } from './main';
import SearchFilter from './search-filter';
import { SortingList } from './sorting-list';

export default class CompanyAddress {
    init(): void {
        const popupElements: PopupElements = {
            addItemButton: document.querySelector('[data-action="AddAddress"]'),
            editButtons: Array.from(
                document.querySelectorAll('[data-action="EditAddress"]')
            ),
            deleteButtons: Array.from(
                document.querySelectorAll('[data-action="RemoveAddress"]')
            )
        };

        const popupComponent: PopupComponent = {
            displayComponentName: 'CustomerAddressForm',
            removeItemUrl: 'CustomerCenter/DeleteCompanyAddress',
            addItemUrlParameters: [
                {
                    fieldName: 'type',
                    dataAttributeTargetValue: 'data-address-type'
                }
            ],
            editItemUrlParameters: [
                {
                    fieldName: 'addressId',
                    dataAttributeTargetValue: 'data-address-id'
                },
                {
                    fieldName: 'type',
                    dataAttributeTargetValue: 'data-address-type'
                }
            ],
            removeItemUrlParameters: [
                {
                    fieldName: 'addressId',
                    dataAttributeTargetValue: 'data-address-id'
                }
            ]
        };

        new EditListPopup().init(
            'AddressForm',
            'address-form-popup',
            popupElements,
            popupComponent,
            () => this.reloadComponent(),
            () => this.reloadComponent()
        );

        const component = document.querySelector(
            '[data-component=CustomerCompanyAddresses]'
        );
        const filter = new SearchFilter(component, initCompanyAddress);
        new SortingList(component, initCompanyAddress, [], filter);
    }

    private reloadComponent(): void {
        const action = new ActionCreator().reloadComponent(
            'CustomerCompanyAddresses'
        );
        action.successAction = () => initCompanyAddress();
        new AjaxDispatcher().dispatchGetAction(action);
    }
}
